<!--
 * @Author: your name
 * @Date: 2022-02-14 19:04:41
 * @LastEditTime: 2022-04-20 15:03:17
 * @LastEditors: wangjiaxiang
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xingmahui_front/src/views/contents/expertsView/components/comment.vue
-->
<template>
  <div class="PublishComment">
    <div class="iconWrap">
      <!-- 点赞 -->
      <span class="commentShare">
        <div @click.stop="onLike(videoDetail.orLike)">
          <img
              :src="
              videoDetail.orLike == false
                ? require('@/assets/images/bjDoctor/give_like.png')
                : require('@/assets/images/bjDoctor/give_like_active1.png')
            "
              alt=""
              style="width:30px;height:30px;padding-bottom:2px"
          />
          <p class="num">{{ fomatterNum(videoDetail.like) }}</p>
        </div>
      </span>
      <!-- 收藏 -->

      <span class="commentShare share3">
        <div @click.stop="onCllect(videoDetail.orFavorites)">
          <img
              :src="
              videoDetail.orFavorites == false
                ? require('@/assets/images/bjDoctor/collection.png')
                : require('@/assets/images/bjDoctor/collection_active1.png')
            "
              alt=""
              class="share2"
              style="width:30px;height:30px;padding-bottom:2px"
          />
          <p class="num">{{ fomatterNum(videoDetail.collect) }}</p>
        </div>
        <!-- <div>
          <img
            src="@/assets/images/baby/icon2.png"
            alt=""
            class="share2"
            style="width:19px;height:19px"
          />
          <span class="num">{{ fomatterNum() }}</span>
        </div> -->
      </span>

      <!-- 评论 -->
      <span class="commentShare share1">
        <div @click.stop="showComment">
          <img
              alt=""
              class="share2"
              src="@/assets/images/bjDoctor/comments.png"
              style="width:30px;height:30px"
          />
          <p class="num">{{ fomatterNum(videoDetail.commentNum) }}</p>
        </div>
      </span>
      <!-- 分享 -->
      <span class="commentShare share2">
        <div>
          <img
              alt=""
              class="share1"
              src="@/assets/images/bjDoctor/share.png"
              style="width:30px;height:30px"
              @click="share()"
          />
          <p class="num">{{ fomatterNum(videoDetail.share) }}</p>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import * as until from "@/assets/js/common.js"; //公共方法
import {fomatterNum, getCookie, throttle,} from "@/assets/js/common.js";
import API_ from "@/utils/axiosApi/foodApi"; //api
import taskMinxin from "@/minxs/taskFinish"; //混入完成任务方法
export default {
  name: "comment",
  mixins: [taskMinxin],
  data() {
    return {
      parameter: {
        moduleType: "0", //京城名医8 辅食5
      },
    };
  },

  computed: {},
  props: ["videoDetail", "articalId", "isGoLogin", "carrierId"],
  mounted() {
  },
  destroyed() {
  },
  watch: {
    videoDetail: {
      immediate: true, //这句重要
      deep: true, //深监听
      handler(newValue) {
        console.log(newValue, '&&&&&&&&&&&&&&&');
        if (newValue.isFood) {
          this.parameter.moduleType = "5";
        } else {
          this.parameter.moduleType = "8";
        }
      },
    },
  },
  methods: {
    getCookie,
    fomatterNum,
    // 打开评论
    showComment() {
      this.$emit("showComment");
    },
    // 点赞
    onLike: throttle(function (status) {
      if (this.isGoLogin) {
        this.$parent.$parent.isLogin();
        return;
      }
      API_.foodRecord(
          {},
          {
            recordType: "2",
            moduleType: this.parameter.moduleType,
            recordId: this.videoDetail.id,
            crmId: until.getUserInfo(),
            isClick: status,
          },
          (res) => {
            if (res.code === "200") {
              if (status == true) {
                this.videoDetail.like > 0 && this.videoDetail.like--;
                this.videoDetail.orLike = false;
                this.praiseSaveSensor("Unsupport");
                this.$toast("取消点赞成功");
              } else {
                this.videoDetail.like++;
                this.videoDetail.orLike = true;
                var relation = "jcmy_praise" + this.videoDetail.id;
                this.taskFinish("1"); //成长值任务
                this.praiseSaveSensor("Support");
              }
            }
          }
      );
    }, 300),
    onCllect: throttle(function (status) {
      console.log(status);
      if (this.isGoLogin) {
        this.$parent.$parent.isLogin();
        return;
      }
      API_.foodRecord(
          {},
          {
            recordType: "1",
            moduleType: this.parameter.moduleType,
            recordId: this.videoDetail.id,
            crmId: until.getUserInfo(),
            isClick: status,
          },
          (res) => {
            if (res.code === "200") {
              if (status == true) {
                this.praiseSaveSensor("CancelSave");

                this.videoDetail.collect > 0 && this.videoDetail.collect--;
                this.videoDetail.orFavorites = false;
                this.$toast("取消收藏成功");
              } else {
                this.videoDetail.collect++;
                this.videoDetail.orFavorites = true;
                var relation = "jcmy_collect" + this.videoDetail.id;
                this.taskFinish("2"); //成长值任务
                this.praiseSaveSensor("Save");
              }
            }
          }
      );
    }, 300),
    share() {
      this.$emit("share");
    },
    // 神策埋点
    praiseSaveSensor(type) {
      sensors.track(type, {
        content_id: this.videoDetail.id,
        content_title: this.videoDetail.name,
        Column: "京城名医",
        Poster_Date: "",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.PublishComment {
  top: 221px;
  right: 4px;
  display: block;
  position: absolute;
  z-index: 1000;

  .iconWrap {
    .commentShare {
      display: block;
      padding-bottom: 11px;

      div {
        text-align: center;
        color: #ffffff;
        padding: 5px 10px 5px;
      }

      &:nth-child(3) {
        padding-bottom: 21px;
      }
    }
  }
}
</style>
